export default __webpack_public_path__ + "static/media/0010.34d2daf5.jpg";